module.exports = __webpack_public_path__ + "static/media/store-empty.5f79f1c1.svg";